import {
  OPTICS_POOL_NAME,
  PULSE_POOL_NAME
} from '../../../solaris-lens-common-lib/src/constants/services';

const LOCALHOST_PULSE_URL = 'http://localhost:5173/';
const LOCALHOST_OPTICS_URL = 'http://localhost:3000/';

export const EXTERNAL_LINKS = [
  {
    id: 'navigationMenuGoToPowerWeb',
    poolName: PULSE_POOL_NAME,
    host: 'solaris-pulse.com',
    localhost: LOCALHOST_PULSE_URL,
    text: 'Go to Pulse Web'
  },
  {
    id: 'navigationMenuGoToOpticsWeb',
    poolName: OPTICS_POOL_NAME,
    host: 'solaris-optics.com',
    localhost: LOCALHOST_OPTICS_URL,
    text: 'Go to Optics Web'
  }
];
